var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderMaintenanceDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 597,
    height: 509,
    viewBox: "0 0 597 509",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    opacity: 0.128511,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.049 201.131C225.758 195.885 231.392 193.014 236.64 194.715L450.75 264.103C456.01 265.808 458.888 271.457 457.175 276.713L406.403 432.568C404.695 437.813 399.06 440.684 393.812 438.983L179.702 369.595C174.443 367.891 171.564 362.242 173.277 356.985L224.049 201.131Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    opacity: 0.216285,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.198 55.3661C301.907 50.1206 307.541 47.2498 312.79 48.9506L552.488 126.631C557.747 128.336 560.626 133.984 558.913 139.241L501.983 314C500.274 319.246 494.64 322.117 489.392 320.416L249.693 242.735C244.434 241.031 241.555 235.382 243.268 230.125L300.198 55.3661Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3",
    opacity: 0.226656,
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1162 20.7962C64.825 15.5507 70.4591 12.68 75.7073 14.3808L200.733 54.8985C205.992 56.603 208.871 62.252 207.158 67.5089L178.249 156.25C176.54 161.496 170.906 164.367 165.658 162.666L40.6325 122.148C35.3729 120.444 32.4946 114.795 34.2072 109.538L63.1162 20.7962Z",
    fill: "url(#paint2_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4",
    opacity: 0.216285,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M459.01 376.356C460.719 371.11 466.353 368.239 471.601 369.94L525.549 387.423C530.808 389.128 533.686 394.777 531.974 400.034L503.065 488.775C501.356 494.021 495.722 496.891 490.474 495.191L436.526 477.708C431.267 476.003 428.388 470.354 430.101 465.097L459.01 376.356Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5",
    opacity: 0.128511,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M544.274 279.284C545.983 274.038 551.617 271.168 556.865 272.869L587.12 282.673C592.38 284.378 595.258 290.027 593.545 295.284L576.03 349.051C574.321 354.297 568.687 357.168 563.439 355.467L533.184 345.662C527.924 343.957 525.046 338.308 526.758 333.052L544.274 279.284Z",
    fill: "url(#paint4_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Cloud Storage"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Phone1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.011 111.871C131.011 97.9886 142.265 86.7344 156.148 86.7344H306.632C320.515 86.7344 331.769 97.9886 331.769 111.871V478.328C331.769 492.211 320.515 503.465 306.632 503.465H156.148C142.265 503.465 131.011 492.211 131.011 478.328V111.871Z",
    fill: "#00CFE8",
    fillOpacity: 0.225361
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.251 123.606C138.251 113.377 146.544 105.084 156.773 105.084H305.349C315.578 105.084 323.87 113.377 323.87 123.606V472.067C323.87 482.296 315.578 490.589 305.349 490.589H156.773C146.544 490.589 138.251 482.296 138.251 472.067V123.606Z",
    fill: "#252D41"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 105,
    width: 186,
    height: 386
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.251 123.606C138.251 113.377 146.544 105.084 156.773 105.084H305.349C315.578 105.084 323.87 113.377 323.87 123.606V472.067C323.87 482.296 315.578 490.589 305.349 490.589H156.773C146.544 490.589 138.251 482.296 138.251 472.067V123.606Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 222.555,
    cy: 327.082,
    rx: 15.9208,
    ry: 15.9236,
    fill: "#68DE9E",
    fillOpacity: 0.642073
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.623 328.077C201.076 328.077 235.491 362.498 235.491 404.958C235.491 447.419 201.076 481.839 158.623 481.839C116.171 481.839 81.7559 447.419 81.7559 404.958C81.7559 362.498 116.171 328.077 158.623 328.077ZM158.623 361.666C134.718 361.666 115.339 381.048 115.339 404.958C115.339 428.868 134.718 448.251 158.623 448.251C182.529 448.251 201.908 428.868 201.908 404.958C201.908 381.048 182.529 361.666 158.623 361.666Z",
    fill: "url(#paint5_linear)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M250.232 93.5325C251.95 93.5325 253.342 94.8692 253.342 96.5182C253.342 98.1305 252.011 99.4443 250.346 99.5019L250.232 99.5038H195.17C193.453 99.5038 192.061 98.1671 192.061 96.5182C192.061 94.9058 193.392 93.592 195.056 93.5344L195.17 93.5325H250.232Z",
    fill: "#56CDD9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M260.346 93.0347C262.063 93.0347 263.455 94.4271 263.455 96.1448C263.455 97.8242 262.124 99.1928 260.46 99.2528L260.346 99.2548H260.183C258.465 99.2548 257.073 97.8624 257.073 96.1448C257.073 94.4653 258.404 93.0967 260.069 93.0367L260.183 93.0347H260.346Z",
    fill: "#56CDD9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.011 311.734C307.011 308.421 309.697 305.734 313.011 305.734H343.375L355.011 317.734V356.734C355.011 360.048 352.324 362.734 349.011 362.734H313.011C309.697 362.734 307.011 360.048 307.011 356.734V311.734Z",
    fill: "#FB9C9D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PDF",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.052 347.734V342.964H320.076C321.456 342.964 322.53 342.616 323.298 341.92C324.066 341.224 324.45 340.252 324.45 339.004C324.45 337.756 324.066 336.784 323.298 336.088C322.53 335.392 321.456 335.044 320.076 335.044V335.044H314.244V347.734H317.052ZM319.716 340.84H317.052V337.186H319.716C320.424 337.186 320.952 337.336 321.3 337.636C321.648 337.936 321.822 338.398 321.822 339.022C321.822 340.234 321.12 340.84 319.716 340.84V340.84ZM331.2 347.734C332.592 347.734 333.786 347.482 334.782 346.978C335.778 346.474 336.537 345.745 337.059 344.791C337.581 343.837 337.842 342.7 337.842 341.38C337.842 340.06 337.578 338.926 337.05 337.978C336.522 337.03 335.76 336.304 334.764 335.8C333.768 335.296 332.58 335.044 331.2 335.044V335.044H326.268V347.734H331.2ZM331.002 345.466H329.076V337.312H331.002C333.702 337.312 335.052 338.668 335.052 341.38C335.052 344.104 333.702 345.466 331.002 345.466V345.466ZM342.774 347.734V342.388H348.21V340.174H342.774V337.258H348.57V335.044H340.002V347.734H342.774Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    opacity: 0.33996,
    d: "M355.011 317.734H346.375C344.718 317.734 343.375 316.391 343.375 314.734V305.734L355.011 317.734Z",
    fill: "#EA5455"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 28_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.011 387.734C169.011 384.421 171.697 381.734 175.011 381.734H205.375L217.011 393.734V432.734C217.011 436.048 214.324 438.734 211.011 438.734H175.011C171.697 438.734 169.011 436.048 169.011 432.734V387.734Z",
    fill: "#FFBC7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.011 414.234C177.011 413.958 177.235 413.734 177.511 413.734H184.511C184.787 413.734 185.011 413.958 185.011 414.234V428.234C185.011 428.511 184.787 428.734 184.511 428.734H177.511C177.235 428.734 177.011 428.511 177.011 428.234V414.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.011 404.234C189.011 403.958 189.235 403.734 189.511 403.734H196.511C196.787 403.734 197.011 403.958 197.011 404.234V428.234C197.011 428.511 196.787 428.734 196.511 428.734H189.511C189.235 428.734 189.011 428.511 189.011 428.234V404.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.011 411.234C201.011 410.958 201.235 410.734 201.511 410.734H208.511C208.787 410.734 209.011 410.958 209.011 411.234V428.234C209.011 428.511 208.787 428.734 208.511 428.734H201.511C201.235 428.734 201.011 428.511 201.011 428.234V411.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    opacity: 0.732678,
    d: "M217.011 393.734H208.375C206.718 393.734 205.375 392.391 205.375 390.734V381.734L217.011 393.734Z",
    fill: "#FC9735"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 28_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.011 350.734C237.011 347.421 239.697 344.734 243.011 344.734H273.375L285.011 356.734V395.734C285.011 399.048 282.324 401.734 279.011 401.734H243.011C239.697 401.734 237.011 399.048 237.011 395.734V350.734Z",
    fill: "#B7B0FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 31"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval_3",
    cx: 253.302,
    cy: 381.884,
    r: 4.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_4",
    cx: 264.811,
    cy: 379.813,
    r: 4.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.611 364.338V379.451H267.811L267.81 368.012L258.088 371.164V381.74H256.288L256.289 368.655L269.611 364.338Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    opacity: 0.33996,
    d: "M285.011 356.734H276.375C274.718 356.734 273.375 355.391 273.375 353.734V344.734L285.011 356.734Z",
    fill: "#564EA6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_15",
    opacity: 0.272833,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.122 161.486C292.122 155.548 287.308 150.734 281.37 150.734H180.215C174.277 150.734 169.463 155.548 169.463 161.486V282.347C169.463 288.285 174.277 293.099 180.215 293.099H281.37C287.308 293.099 292.122 288.285 292.122 282.347V161.486Z",
    fill: "#00CFE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.845 172.164C282.845 166.225 278.031 161.412 272.093 161.412H190.881C184.943 161.412 180.129 166.225 180.129 172.164V182.414C180.129 188.352 184.943 193.166 190.881 193.166H272.093C278.031 193.166 282.845 188.352 282.845 182.414V172.164Z",
    fill: "#F4FEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.9 177.178C275.9 171.419 271.232 166.75 265.473 166.75H264.107C258.348 166.75 253.68 171.419 253.68 177.178V177.178C253.68 182.936 258.348 187.605 264.107 187.605H265.473C271.232 187.605 275.9 182.936 275.9 177.178V177.178Z",
    fill: "#7367F0",
    fillOpacity: 0.210173
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.845 213.872C282.845 207.934 278.031 203.12 272.093 203.12H190.881C184.943 203.12 180.129 207.934 180.129 213.872V224.122C180.129 230.06 184.943 234.874 190.881 234.874H272.093C278.031 234.874 282.845 230.06 282.845 224.122V213.872Z",
    fill: "#F4FEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.9 218.886C275.9 213.127 271.232 208.459 265.473 208.459H264.107C258.348 208.459 253.68 213.127 253.68 218.886V218.886C253.68 224.645 258.348 229.313 264.107 229.313H265.473C271.232 229.313 275.9 224.645 275.9 218.886V218.886Z",
    fill: "#7367F0",
    fillOpacity: 0.210173
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.845 255.58C282.845 249.642 278.031 244.828 272.093 244.828H190.881C184.943 244.828 180.129 249.642 180.129 255.58V265.83C180.129 271.768 184.943 276.582 190.881 276.582H272.093C278.031 276.582 282.845 271.768 282.845 265.83V255.58Z",
    fill: "#F4FEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.9 260.594C275.9 254.835 271.232 250.167 265.473 250.167H264.107C258.348 250.167 253.68 254.835 253.68 260.594V260.594C253.68 266.353 258.348 271.021 264.107 271.021H265.473C271.232 271.021 275.9 266.353 275.9 260.594V260.594Z",
    fill: "#7367F0",
    fillOpacity: 0.210173
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.011 141.44C394.011 139.231 395.802 137.44 398.011 137.44L404.306 137.44C406.515 137.44 408.306 139.231 408.306 141.44V144.274C408.306 144.947 408.852 145.493 409.526 145.493H454.937C457.146 145.493 458.937 147.284 458.937 149.493V188.307C458.937 190.517 457.146 192.307 454.937 192.307H398.011C395.802 192.307 394.011 190.517 394.011 188.307V141.44Z",
    fill: "#FF9F43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M409.413 142.277C409.508 141.686 410.018 141.25 410.618 141.25H460.212C460.962 141.25 461.534 141.921 461.416 142.662L453.965 189.375C453.871 189.967 453.36 190.402 452.761 190.402H403.166C402.416 190.402 401.844 189.732 401.962 188.991L409.413 142.277Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M462.705 153.733C465.221 153.733 467.112 156.027 466.632 158.496L461.196 186.453C460.465 190.212 457.172 192.926 453.343 192.926H398.863C396.348 192.926 394.457 190.632 394.937 188.163L400.373 160.206C401.104 156.447 404.396 153.733 408.226 153.733L462.705 153.733Z",
    fill: "#FABB7E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 28_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.011 233.734C360.011 230.421 362.697 227.734 366.011 227.734H422.011C425.324 227.734 428.011 230.421 428.011 233.734V278.734C428.011 282.048 425.324 284.734 422.011 284.734H366.011C362.697 284.734 360.011 282.048 360.011 278.734V233.734Z",
    fill: "#77ECAB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.185 247.306C386.642 247.042 386.011 247.437 386.011 248.04V264.398C386.011 265.008 386.657 265.403 387.2 265.124L403.558 256.729C404.156 256.422 404.147 255.563 403.542 255.269L387.185 247.306Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    x: 367.011,
    y: 232.734,
    width: 6,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    x: 379.011,
    y: 232.734,
    width: 6,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    x: 391.011,
    y: 232.734,
    width: 6,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    x: 403.011,
    y: 232.734,
    width: 6,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    x: 415.011,
    y: 232.734,
    width: 6,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    x: 367.011,
    y: 272.734,
    width: 6,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    x: 379.011,
    y: 272.734,
    width: 6,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    x: 391.011,
    y: 272.734,
    width: 6,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    x: 403.011,
    y: 272.734,
    width: 6,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    x: 415.011,
    y: 272.734,
    width: 6,
    height: 6,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Men3.6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RLeg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4256 481.193L34.8222 502.949L47.2507 502.883L47.6709 480.852L38.4256 481.193Z",
    fill: "#B8B6C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8357 494.736L33.7477 496.569C32.4206 498.036 31.8532 501.069 32.0456 505.667C32.0456 508.743 49.8274 508.652 50.814 505.667C51.1507 500.677 50.546 497.579 49 496.373L48.9903 494.603C48.9841 493.454 48.2068 492.452 47.0915 492.154L44.8411 491.552C42.8993 488.729 40.253 488.829 37.9853 491.905L35.8532 492.365C34.7186 492.611 33.8911 493.583 33.8357 494.736Z",
    fill: "#2F2B57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.5771 309.683C80.5771 309.683 64.5073 397.964 61.6895 407.157C58.8717 416.35 51.0571 485.495 51.0571 485.495L34.1775 485.543C34.1775 485.543 33.8179 432.316 35.523 423.761C37.2281 415.207 41.077 401.119 41.077 401.119C41.077 401.119 43.9367 349.974 45.6475 338.043C47.3578 326.112 52.8487 308.428 52.8487 308.428L80.5771 309.683Z",
    fill: "#2F2B57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3465 375.171L69.8887 363.155L68.7604 366.464C63.1428 383.038 59.3231 395.903 57.3015 405.06C55.6002 412.766 55.2425 426.07 56.2285 444.971L57.3492 435.709C58.965 422.593 60.536 411.082 61.6467 407.298L61.7565 406.931C62.8003 403.336 65.4007 390.446 68.3465 375.171Z",
    fill: "white",
    fillOpacity: 0.192499
  })), /*#__PURE__*/React.createElement("g", {
    id: "LLeg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.252 484.285L90.5959 484.361L90.5991 484.679C90.6365 486.241 91.0621 493.131 95.6171 495.776L96.526 496.312C101.655 499.385 108.751 504.328 108.751 504.328L78.3862 505.361L79.252 484.285Z",
    fill: "#B8B6C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.8215 492.002C78.1617 491.757 76.8319 496.859 76.8319 507.308L90.4498 507.358L91.3726 505.361L92.2397 505.709C94.0863 506.435 95.3978 506.835 96.174 506.911L96.8946 506.977C100.713 507.306 106.004 507.461 112.769 507.44L112.791 507.323C112.906 506.615 113.209 502.834 107.329 499.961L107.053 499.829C100.349 496.688 95.4375 492.252 94.3768 491.662L94.3253 491.634C93.3754 491.167 93.9951 490.903 92.6452 492.002C91.2954 493.1 91.0732 495.987 88.0145 496.078C84.0777 496.195 84.8112 492.369 80.8215 492.002Z",
    fill: "#2F2B57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1021 351.291C69.4528 366.979 72.9992 405.29 72.9992 405.29C72.9992 405.29 73.3996 409.326 71.6664 420.506C69.9331 431.686 76.7626 486.088 76.7626 486.088L94.7387 486.124C94.7387 486.124 96.956 413.041 97.0611 405.354C97.2253 393.369 101.112 310.273 101.112 310.273L63.726 309.422C63.726 309.422 60.7513 335.602 65.1021 351.291Z",
    fill: "#353160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.3146 341.72L91.3852 342.027C93.9677 352.887 89.5389 401.015 90.7997 412.459L91.3019 416.553C92.1783 423.91 93.6615 437.323 95.7512 456.791L96.2045 440.495C96.6206 425.009 96.9744 410.437 97.0509 406.005L97.0611 405.354C97.2253 393.369 101.112 310.274 101.112 310.274L94.1182 310.115L93.8124 311.459C90.725 325.228 89.8924 335.315 91.3146 341.72V341.72Z",
    fill: "white",
    fillOpacity: 0.192499
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 47",
    d: "M97.2244 494.737L98.085 493.244",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 47_2",
    d: "M99.7615 496.443L100.622 494.95",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 47_3",
    d: "M102.298 498.149L103.158 496.656",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.9762 201.904C95.881 202.331 95.6042 209.191 90.8508 209.549C89.8793 216.162 86.4145 219.312 82.1904 219.677L82.4246 229.679L63.7399 229.668C63.7399 229.668 69.0015 222.602 68.7392 212.929C68.477 203.255 68.9152 194.168 68.9152 194.168L93.1162 194.602L91.9762 201.904Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.8504 197.829C95.5341 198.642 94.1936 202.315 93.3411 202.315C89.4299 200.769 86.1872 206.334 84.5388 211.924C79.8575 216.513 69.514 216.615 68.4454 212.776C64.3997 204.367 64.2013 192.208 68.9224 191.27C65.2164 181.498 115.266 176.387 93.8504 197.829Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 45",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.6712 213.296C89.479 212.874 88.3327 215.759 86.4798 217.305C84.5622 218.905 81.6838 219.373 82.1907 219.677C86.081 222.006 91.2373 216.729 89.6712 213.296Z",
    fill: "url(#paint9_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5116 248.307C17.5116 248.307 18.3325 242.78 18.072 239.143C17.5901 232.416 18.5117 226.742 17.0222 225.859C15.1117 224.727 14.6339 234.771 14.6339 234.771C14.6339 234.771 3.72306 217.009 1.44838 219.155C-0.826297 221.301 3.91861 230.635 3.16624 233.333C2.41387 236.032 9.93231 249.086 9.93231 249.086L17.5116 248.307Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.845 251.5C57.845 251.5 41.3181 277.207 37.6669 282.192C33.8371 287.42 27.0734 289.736 22.2734 281.395C18.0279 274.016 8.93744 255.539 7.78693 249.795C6.92858 245.51 15.7205 239.122 19.9461 245.526C24.1716 251.929 30.8452 261.558 30.8452 261.558C30.8452 261.558 41.8193 241.677 45.2403 236.986C54.4661 224.336 68.5228 235.695 57.845 251.5Z",
    fill: "#02C4DC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8447 261.558L27.2134 267.81L28.5367 258.16L30.8447 261.558Z",
    fill: "black",
    fillOpacity: 0.159856
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 54",
    d: "M19.6387 245.733C15.7992 244.519 12.2835 245.165 9.47805 249.89",
    stroke: "#5386BF",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7654 224.805L85.0723 224.93L85.8626 225.249C89.0475 226.555 100.876 231.64 103.079 235.996C106.761 243.273 101.91 301.581 104.025 305.099C108.486 312.522 102.659 317.64 83.2949 319.577L82.704 319.634C62.868 321.525 45.2702 319.977 48.4636 309.971C51.6577 299.965 41.8849 235.518 51.0492 231.067L65.7654 224.805Z",
    fill: "#00CFE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5869 239.572C83.7265 245.799 89.4079 262.004 103.631 288.188L103.807 282.339C104.272 267.738 104.956 249.941 104.097 240.985C95.114 234.187 89.2775 233.715 86.5869 239.572Z",
    fill: "black",
    fillOpacity: 0.159856
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_36",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.3714 223.096C85.1703 222.769 65.0575 223.096 64.2584 223.096C63.4593 223.096 63.4593 226.514 64.2584 226.514C64.747 226.514 70.9845 226.421 86.3729 226.235C87.7615 226.218 91.4658 227.788 91.4658 227.788C91.4658 227.788 87.5725 223.424 86.3714 223.096Z",
    fill: "url(#paint11_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.395 282.495C164.395 282.495 174.925 284.167 176.911 282.525C178.897 280.884 186.809 269.723 185.945 267.803C185.081 265.883 177.862 269.944 177.247 268.723C176.456 267.154 180.538 261.557 176.961 261.231C176.04 261.147 175.389 264.592 172.795 266.861C170.202 269.13 163.942 274.164 163.942 274.164L164.395 282.495Z",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.761 233.366C109.861 242.024 122.745 262.471 125.491 264.272C128.236 266.073 162.58 269.707 165.814 272.639C168.515 275.089 168.758 282.543 165.814 284.61C162.869 286.678 124.202 283.906 117.11 281.84C110.018 279.774 97.8713 260.84 92.4454 254.93C77.2714 238.403 91.6609 224.708 100.761 233.366Z",
    fill: "#02C4DC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 53",
    d: "M162.241 271.439C163.941 273.428 164.799 276.327 163.941 281.991",
    stroke: "#5386BF",
    strokeLinecap: "round"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 20.2411,
    y: 0.302166,
    width: 200.882,
    height: 176.442,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.43656,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 68.2289,
    y1: 395.784,
    x2: 344.215,
    y2: 543.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28C76F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 167.137,
    y1: 194.207,
    x2: 326.377,
    y2: 347.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CFE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: -31.8552,
    y1: 137.056,
    x2: 138.616,
    y2: 228.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77ECAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 408.135,
    y1: 456.423,
    x2: 465.347,
    y2: 491.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CFE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 498.344,
    y1: 360.309,
    x2: 559.885,
    y2: 386.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28C76F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 114.08,
    y1: 508.651,
    x2: 239.749,
    y2: 444.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88EFB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 456.573,
    y1: 156.675,
    x2: 456.573,
    y2: 127.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 100.036,
    y1: 185.523,
    x2: 96.9075,
    y2: 227.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 96.4306,
    y1: 193.363,
    x2: 58.6147,
    y2: 193.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222735"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 92.4179,
    y1: 224.028,
    x2: 77.6825,
    y2: 226.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D63A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222735"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 21.1162,
    y1: 211.645,
    x2: 17.1213,
    y2: 247.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 142.374,
    y1: 216.056,
    x2: 142.318,
    y2: 239.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#648BF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 189.83,
    y1: 255.87,
    x2: 188.141,
    y2: 282.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderMaintenanceDark);
export default __webpack_public_path__ + "static/media/under-maintenance-dark.c61400e0de300179398031da81eade11.svg";
export { ForwardRef as ReactComponent };